import { PortalAdministrationRoute, MyInformationRoute, OrdersRoute, OrderRoute, SSOOrderRoute, SSOSiteSearchRoute, SSOGetAuthFormRoute } from "../config/Routes"
import HasAccessToRoute from "./hasAccessToRoute"
import UserAccessSettings from "./UserAccessSettings"
import UserState from "./UserState"

export function GetUserDefaultRoute(userAccess: UserAccessSettings, userState: UserState): string {
  const isSSO = userState.ssoToken !== ""
  const routes = userAccess.isSiteAdmin ? [PortalAdministrationRoute, MyInformationRoute] : (isSSO ? [SSOSiteSearchRoute, SSOOrderRoute, SSOGetAuthFormRoute] : [OrdersRoute, OrderRoute, MyInformationRoute])
  return routes.find(route => HasAccessToRoute(route, userAccess, userState)) || ""
}
